import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const searchDate = this.props.searchDate;
    const chequeCustomerData = this.props.chequeCustomerData;
    const total = this.props.total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
    const selectedDatePDF = this.props.selectedDatePDF;

    return (
      <div>
        <h2><center>Cheque Customer Details Report</center></h2>
        <div>&nbsp;</div>
        <h2><center> {searchData.groupName} - {searchData.factoryName}</center></h2>
        <div>&nbsp;</div>
        <h2><center> Route : {searchData.routeName === undefined ? "All Routes" : searchData.routeName}</center></h2>
        <div>&nbsp;</div>
        <h3><center>Bought leaf direct cheque payment for the month of {searchData.monthName} - {searchData.year}</center></h3>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow style={{ border: "1px solid black" }}>
                    <TableCell align={'left'} style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }}>Route Name</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }}>Reg No</TableCell>
                    <TableCell align={'left'} style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }}>Customer Name</TableCell>
                    <TableCell align={'right'} style={{ border: "1px solid black", padding: '2px 5px' }}>Amount (Rs)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chequeCustomerData.map((data, index) => (
                    <TableRow key={index} style={{ border: "1px solid black" }}>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", fontSize: '0.9rem', padding: '2px' }}>
                        {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableRow style={{ border: "1px solid black" }}>
                  <TableCell align={'center'} style={{ border: "1px solid black", padding: '2px 5px', fontSize: '0.9rem' }} colSpan={3}><b>Total</b></TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ fontSize: '0.9rem', border: "1px solid black", padding: '2px' }}>
                    <b> {total} </b>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h4><center>*******End of List*******</center></h4>
      </div>
    );

  }

}
